import { get } from "lodash";
import {
  isNonSupportedTypeFound,
  listTerraformDefaultParameterValue,
} from "../modules/blueprints/helpers/terraformParameters";
import { convertListValueLabel } from "../utils/convert-select-value";
import { isNotEmptyString } from "./format-string";
import { getParametersRequest } from "./parameter";
import resourceList from "./resourceList.json";

export const getBlueprintLaunchRequest = ({
  parameters,
  task,
  orgId,
  stackName,
  isSelfManagedUser,
  selectedConfig,
  selectedDept,
}) => {
  const { selectedCapabilities, selectedAccount, selectedRegion } = task;

  const id = get(selectedConfig, "id", "");

  const accountNumber = selectedAccount && selectedAccount.accountNumber;
  const departmentId = selectedDept && selectedDept.ID;
  const regionCode = selectedRegion;

  const params = {
    AccountNumber: accountNumber,
    RegionCode: regionCode,
    Action: "launchBlueprint",
    StackName: stackName,
    OrganizationId: orgId,
    DepartmentId: departmentId,
    Capabilities: selectedCapabilities.map((sc) => sc.value),
    Parameters:
      parameters && Array.isArray(parameters)
        ? getParametersRequest(parameters, isSelfManagedUser)
        : [],
    LaunchConfigId: id,
  };

  return params;
};

export const preProcessParameters = (
  parameters,
  configParameters,
  outputParameters,
  isDeployingBP
) => {
  let processedParams = [];
  const resources = Object.keys(resourceList);

  parameters &&
    parameters.length > 0 &&
    parameters.forEach((p) => {
      let param = { ...p };
      const isResourceType = resources.find(
        (res) => res === param.parameterType
      );
      const configParam =
        configParameters &&
        configParameters.find((p) => p.ParameterKey === param.parameterKey);
      const outputParam =
        outputParameters &&
        outputParameters.find((p) => p.OutputKey === param.parameterKey);

      param.parameterValue =
        param.parameterValue && isNotEmptyString(param.parameterValue)
          ? param.parameterValue.toString()
          : configParam
          ? configParam.ParameterValue
          : outputParam
          ? outputParam.OutputValue
          : param.defaultValue
          ? isResourceType && isDeployingBP
            ? param.defaultValue
            : typeof string === "string"
            ? param.defaultValue.toString()
            : param.defaultValue
          : "";

      if (param.parameterType === "List") {
        param.parameterValue =
          param.parameterValue && isNotEmptyString(param.parameterValue)
            ? Array.isArray(param.parameterValue)
              ? convertListValueLabel(param.parameterValue)
              : convertListValueLabel(param.parameterValue)[0]
            : null;
      }

      if (param.parameterType && isNonSupportedTypeFound(param.parameterType)) {
        param.parameterValue = listTerraformDefaultParameterValue(
          param.parameterType,
          param.parameterValue
        );
      }

      //if resource type is a resource picker
      if (isResourceType) {
        param.parameterValue = Array.isArray(param.parameterValue)
          ? param.parameterValue
          : isNotEmptyString(param.parameterValue)
          ? [param.parameterValue]
          : param.parameterValue;
      }
      processedParams.push(param);
    });
  return processedParams;
};

export const hasValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (value === null) {
    return value;
  }
  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }
  if (typeof value === "string") {
    return value.trim() ? true : false;
  }
  return value ? true : false;
};

export const resourceMapping = {
  Listener: {
    key: "LoadBalancer",
    apiKey: "Listeners",
    apiSubKey: "ListenerArn",
    mappingKey: "LoadBalancerArn",
    uiMappingKey: "parentResource",
  },
};

export const getResourcePrimaryKey = (primaryKey) => {
  let updatedPrimaryKey = "";
  switch (primaryKey.value) {
    case "ID":
      updatedPrimaryKey = "resourceId";
      break;
    case "ARN":
      updatedPrimaryKey = "resourceArn";
      break;
    case "Name":
      updatedPrimaryKey = "resourceName";
      break;
    default:
      break;
  }
  return updatedPrimaryKey;
};

export const filterResourcesByMapping = (
  resources,
  parameters,
  filterBy,
  parameterMapping
) => {
  return resources.filter((res) => {
    const foundParam = parameters.find(
      (p) => p.parameterKey === (filterBy && filterBy.parameterKey)
    );
    if (foundParam && foundParam.parameterValue) {
      const uiMappingKey = parameterMapping.uiMappingKey;
      const updatedMappingKey =
        (foundParam.primaryKey &&
          foundParam.primaryKey.value &&
          getResourcePrimaryKey(foundParam.primaryKey)) ||
        "resourceId";
      return (
        res[uiMappingKey] &&
        foundParam.parameterValue.includes(res[uiMappingKey][updatedMappingKey])
      );
    }
    return false;
  });
};

export const getInfraConfigDetail = (vpcConfig) => {
  const keyMap = {
    subnets: "SubnetIds",
    vpc: "VpcId",
    region: "DeploymentRegionCode",
    routeTableId: "RouteTableId",
  };
  let infraConfig = {};
  Object.entries(vpcConfig).forEach(([key, data]) => {
    let value = data.value;
    if (key === "subnets") {
      value = data.map((item) => item.value);
    }
    infraConfig[keyMap[key]] = value;
  });
  return infraConfig;
};
